import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "stores";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import { NavigationLink } from "types";
import * as styles from "./styles";
import logout from "../../helpers/logout";
import { ListviewIcon } from "../../assets/icons/listview";
import { LangContext } from "index";

interface IProps {
  links: NavigationLink[];
  authed: boolean;
}

const Menu: React.FC<IProps> = ({ links, authed }) => {
  const [open, setOpen] = React.useState(false);

  const { lang, setLang } = React.useContext(LangContext);

  return (
    <div className={styles.menu}>
      <div className={styles.menuButton} onClick={() => setOpen(!open)}>
        <div>
          <FormattedMessage id="components.Menu.Menu" />
        </div>
        <ListviewIcon color={"black"} size={22} />
      </div>
      <div className={`${styles.menuItems} ${open ? styles.open : styles.closed}`}>
        {authed &&
          links.map((link) => (
            <NavLink
              key={link.to}
              end={link.exactMatch}
              to={link.to}
              onClick={() => setOpen(false)}
            >
              {link.text}
            </NavLink>
          ))}

        <div className={styles.bottomLinks}>
          <div
            onClick={() => {
              setLang(lang === "en" ? "nb" : "en");
              setOpen(false);
            }}
          >
            {lang === "en" ? "Bytt til norsk" : "Switch to english"}
          </div>
          {authed && (
            <div onClick={logout}>
              <FormattedMessage id="components.Header.logout" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default connect((state: ApplicationState) => ({
  authed: !!state.user.userData,
}))(Menu);
